import { forwardRef } from "react";
import { shortId, fmtDateTime, itemCount, mapsLink } from "@/lib/format";
import { LEGAL_NAME } from "@/lib/brand";

// Kitchen Order Ticket — big, price-free, for the kitchen. Auto-prints on accept.
const KotTicket = forwardRef(function KotTicket({ order, vendor, subMap, outlet }, ref) {
  if (!order) return <div id="kot" className="print-doc" ref={ref} />;

  return (
    <div id="kot" className="print-doc" ref={ref} style={{ fontFamily: "'JetBrains Mono', monospace", color: "#000" }}>
      <div style={{ textAlign: "center", borderBottom: "3px solid #000", paddingBottom: 6, marginBottom: 8 }}>
        <div style={{ fontWeight: 900, fontSize: "30px", letterSpacing: 2 }}>KOT</div>
        <div style={{ fontWeight: 700, fontSize: "16px" }}>{vendor?.shop_name || order.restaurant_name || "Kitchen"}</div>
        {outlet?.address && (
          <div data-testid="kot-shop-address" style={{ fontSize: "12px", fontWeight: 600, lineHeight: 1.25 }}>
            {outlet.address}{outlet.pincode ? ` - ${outlet.pincode}` : ""}
          </div>
        )}
        {mapsLink(outlet) && (
          <div style={{ fontSize: "11px", fontWeight: 700, wordBreak: "break-all" }}>Map: {mapsLink(outlet)}</div>
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "18px", fontWeight: 800 }}>
        <span>{shortId(order.id)}</span>
        <span>{itemCount(order)} item(s)</span>
      </div>
      <div style={{ fontSize: "14px", fontWeight: 600, marginTop: 2 }}>{fmtDateTime(order.created_at)}</div>
      {order.customer_name ? (
        <div style={{ fontSize: "17px", fontWeight: 800, marginTop: 3 }}>Cust: {order.customer_name}</div>
      ) : null}
      {order.prep_time_min ? (
        <div style={{ fontSize: "16px", fontWeight: 800, marginTop: 4 }}>PREP: {order.prep_time_min} MIN</div>
      ) : null}

      <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />

      {(order.items || []).map((it, i) => {
        const sub = subMap?.[it.menu_item_id];
        return (
        <div key={`${it.menu_item_id || it.name}-${i}`} style={{ marginBottom: 10 }}>
          {sub ? (
            <div style={{ fontSize: "12px", fontWeight: 900, letterSpacing: 1, textTransform: "uppercase", color: "#000", border: "2px solid #000", display: "inline-block", padding: "0 6px", borderRadius: 3, marginBottom: 3 }}>{sub}</div>
          ) : null}
          <div style={{ display: "flex", gap: 8, fontSize: "20px", fontWeight: 900, lineHeight: 1.25 }}>
            <span style={{ minWidth: "34px" }}>{it.quantity || 1}x</span>
            <span>{it.name}</span>
          </div>
          {it.variant && !(it.name || "").toLowerCase().includes(String(it.variant).toLowerCase()) ? (
            <div style={{ fontSize: "15px", fontWeight: 700, paddingLeft: 42 }}>» {it.variant}</div>
          ) : null}
          {it.notes ? (
            <div style={{ fontSize: "14px", fontWeight: 600, paddingLeft: 42 }}>Note: {it.notes}</div>
          ) : null}
        </div>
        );
      })}

      {order.instructions ? (
        <>
          <div style={{ borderTop: "2px dashed #000", margin: "8px 0" }} />
          <div style={{ fontSize: "16px", fontWeight: 800 }}>NOTE: {order.instructions}</div>
        </>
      ) : null}

      <div style={{ borderTop: "3px solid #000", marginTop: 8, paddingTop: 6, textAlign: "center", fontSize: "13px", fontWeight: 700 }}>
        1APPONLY
        <div style={{ fontSize: "10px", fontWeight: 500, marginTop: 1 }}>{LEGAL_NAME}</div>
      </div>
    </div>
  );
});

export default KotTicket;
